import { VTH_CARD_LAYOUTS } from "../Variants/VerticalToHorizontalCard/constants";
import ImageWrapper from "../../ImageWrapper";
import { ImageTypes } from "../../ImageWrapper/interface";
import { Image, ImageWrapperProps } from "../../ImageWrapper/interface";

/**
 * @param image - object of type ImageProps
 * @param vthBreakpoints - breakpoints at different screen sizes
 * @returns - image with correct aspect ratio based on vthBreakpoints
 */
export const getImage = (image: Image, vthBreakpoints: object | undefined) => {
    if (!image) return;
    let imageWrapperProps: ImageWrapperProps = {
        ...image,
        imageType: ImageTypes.Image,
    };

    const { aspects } = image;

    if (vthBreakpoints === VTH_CARD_LAYOUTS.HORIZONAL_TWO_COLUMN) {
        imageWrapperProps = {
            ...image,
            url: aspects?.ratio1x1?.url || image.url,
            srcset: [],
            imageType: ImageTypes.Image,
        };
    }

    if (vthBreakpoints === VTH_CARD_LAYOUTS.MIXED_LAYOUT_SECONDARY_CARD) {
        const sources = [
            {
                media: "(min-width: 768px) and (max-width: 963px)",
                srcset: aspects?.ratio1x1?.url,
            },
        ];

        imageWrapperProps = {
            ...image,
            sources: sources,
            imageType: ImageTypes.Picture,
        };
    }

    if (vthBreakpoints === VTH_CARD_LAYOUTS.MIXED_LAYOUT_PRIMARY_CARD) {
        const sources = [
            {
                media: "(max-width: 963px)",
                srcset: aspects?.ratio16x9?.url,
            },
        ];

        imageWrapperProps = {
            ...image,
            url: aspects?.ratio1x1?.url || image.url,
            sources: sources,
            imageType: ImageTypes.Picture,
        };
    }

    return <ImageWrapper {...imageWrapperProps} />;
};
